import { LightModeOutlined as LocationIcon } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import CCLogoImage from 'src/assets/images/navbar/CCLogo.svg?react';
import { PATHS } from 'src/constants/paths';
import { getPaths } from 'src/utils';

import {
  LogoWrapper,
  MenuItem,
  MenuList,
  SidebarWrapper,
} from './Sidebar.styled';

interface SidebarItem {
  path: string;
  icon: React.ReactNode;
  label: string;
}

export const Sidebar = () => {
  const location = useLocation();
  const paths = getPaths(location.pathname).slice(1);

  const ownerOperatorItems: SidebarItem[] = [
    {
      path: PATHS.OO_LOCATION_PAGE,
      icon: <LocationIcon />,
      label: 'Locations',
    },
  ];

  return (
    <SidebarWrapper>
      <LogoWrapper>
        <CCLogoImage />
      </LogoWrapper>

      <MenuList>
        {ownerOperatorItems.map((item, index) => {
          const isLocations = item.label === 'Locations';
          const isSelected = isLocations
            ? location.pathname.startsWith('/locations')
            : paths.includes(item.path.split('?')[0]);

          return (
            <MenuItem key={index} $isSelected={isSelected} to={item.path}>
              <span className="icon">{item.icon}</span>
            </MenuItem>
          );
        })}
      </MenuList>
    </SidebarWrapper>
  );
};
